import components from './components';
// import search from './search';

export default {
  reqMat: {
    ...components,
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/requestedMaterials/index.js